import createNormalizer from 'utils/createNormalizer';
import { announcementSchema } from '../schemas';

export const normalizeAnnouncements = createNormalizer({
  announcements: [announcementSchema]
});
